import Layout from '../../components/Layout'

export default function Projects() {
  return (
    <Layout>
      <div className="max-w-screen-2xl mx-auto px-6 py-6">
        <h1 className="text-2xl font-semibold text-text-primary mb-6">Projects</h1>
        <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
          <div className="text-text-muted mb-2">
            <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
            </svg>
          </div>
          <p className="text-text-secondary font-medium">Projects coming soon</p>
          <p className="text-sm text-text-muted mt-1">Project management features will be available here.</p>
        </div>
      </div>
    </Layout>
  )
}
